const isSessionLoggedIn = ({ sessionState }) =>
  sessionState.token !== null && sessionState.msisdn !== null;

const getSessionId = ({ sessionState }) => sessionState.sessionId;

const getMsisdn = ({ sessionState }) => sessionState.msisdn;

const getCpf = ({ sessionState }) => sessionState.cpf;

const getLastDigits = ({ sessionState }) => sessionState.lastDigits;

const getChannel = ({ sessionState }) => sessionState.channel;

const getClientInfo = ({ sessionState }) => sessionState.clientInfo;

const getClientType = ({ sessionState }) => sessionState.clientType;

export { getSessionId, isSessionLoggedIn, getMsisdn, getCpf, getLastDigits, getChannel, getClientInfo, getClientType };
